import richText from "utilities/richText"

export default function ThreeStatBoxSection({ blok }) {
  const columnStyle = "prose-headings:pb-4 text-white basis-1/2"

  return (
    <section className="bg-primary px-5 py-8 lg:py-16">
      <div className="max-w-screen-xl mx-auto">
        <h2 className="text-white text-center pb-8">{blok?.heading}</h2>
        <div className="flex flex-col lg:flex-row w-full gap-8 justify-stretch pb-8">
          {blok?.stats?.map((box) => (
            <div key={box?._uid} className="border-2 border-secondary py-8 px-8 w-full">
              <h3 className="text-white text-center text-m2">{box?.label}</h3>
              <div className="text-white text-center text-l1 lg:text-xl1">{box?.stat}</div>
            </div>
          ))}
        </div>
        <div className="flex flex-col lg:flex-row gap-8">
          <div className={columnStyle}>{richText(blok?.column_1)}</div>
          <div className={columnStyle}>{richText(blok?.column_2)}</div>
        </div>
      </div>
    </section>
  )
}
